function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M147.7 191L31.03 307.7C15.41 323.3 15.41 348.7 31.03 364.3L119 452.3C126.5 459.8 136.7 464 147.3 464L504 464C508.4 464 512 467.6 512 472C512 476.4 508.4 480 504 480L147.3 480C132.5 480 118.2 474.1 107.7 463.6L19.72 375.6C-2.154 353.7-2.154 318.3 19.72 296.4L264.4 51.72C286.3 29.85 321.7 29.85 343.6 51.72L492.3 200.4C514.2 222.3 514.2 257.7 492.3 279.6L339.9 432H317.3L352.1 396.3L147.7 191zM159 179.7L364.3 384.1L480.1 268.3C496.6 252.7 496.6 227.3 480.1 211.7L332.3 63.03C316.7 47.41 291.3 47.41 275.7 63.03L159 179.7z"
});

function SvgEraserThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserThin);
export default __webpack_public_path__ + "static/media/eraser-thin.4065e1fe.svg";
export { ForwardRef as ReactComponent };